module.exports = __webpack_public_path__ + "img/39.6087f2b9.png";